<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户ID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入用户ID"></el-input>
					</el-form-item>
					<!-- <el-form-item label="手机号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入用户手机号"></el-input>
					</el-form-item> -->
					<el-form-item label="用户名称" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入用户名称"></el-input>
					</el-form-item>
					<el-form-item label="源用户" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.fromUserId" placeholder="请输入源用户ID"></el-input>
					</el-form-item>
					<el-form-item label="源用户名称" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.fromUsername" placeholder="请输入源用户名称"></el-input>
					</el-form-item>
					<!-- <el-form-item label="资产名称" class='tiny'>
						<el-select v-model="searchInfo.integralId" class="big" placeholder="请选择" clear>
							<el-option v-for="item in integralList" :key="item.id" :value="item.id" :label="item.name">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="变动类型" class='tiny'>
						<el-col :span="8">
							<el-select style="width: 200px;" filterable  v-model="searchInfo.type" clearable  class="big" placeholder="请选择"
								clear>
								<el-option v-for="item in typeList" :key="item.id" :value="item.recordTypeKey"
									:label="item.recordTypeName">
								</el-option>
							</el-select>
						</el-col>
					</el-form-item> -->
					<el-form-item label="时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>

					<el-form-item label="收支" class='tiny'>
						<el-select v-model="searchInfo.changeType" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="减少" value="0"></el-option>
							<el-option key="1" label="增加" value="1"></el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="关联商家" v-if="!storeFlage">
						<el-select v-model="searchInfo.storeId" filterable 
							:remote-method="remoteMethod" :loading="storeLoading" remote
							reserve-keyword placeholder="请选择" >
							<el-option v-for="item in storeList" :key="item.id" :value="item.id"
								:label="item.storeName">
							</el-option>
						</el-select>
					</el-form-item>  -->
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
							<!-- <el-button type="primary" @click="editialogVisible()">新增用户</el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>

		<!-- 	<div style="margin: 20px;">
			<div style="font-size: 14px;display: flex;justify-content: start;align-items: center;">
				<div>
					<span style="font-weight: bold;">统计</span><span style="font-size: 12px;">(资产名称必选)</span>：
				</div>
				<div style="margin-right: 30px;">
					总金额: {{allData?allData:0 |intToFloatfour|cutZero}}
				</div>
				<div>
                    总支出: {{allData.bigDecimal1?allData.bigDecimal1:'0'}}
                </div>
			</div>
		</div>
 -->
		<!-- <div style="margin: 20px">
			<div style="font-size: 14px;display: flex;justify-content: start;align-items: center;">
				<div><span style="font-weight: bold">统计：</span></div>
				<div>
					总数量: {{ allData ? allData : 0 | intToFloatfour | cutZero }}
				</div>
			</div>
		</div> -->

		<el-table class="tables" :data="userRecordList.list" stripe style="width: 100%;" 
			:header-cell-style="headClass" v-loading="loading" element-loading-text="拼命加载中"
			element-loading-spinner="el-icon-loading">
			<el-table-column label="用户" align="center" width="170">
				<template slot-scope="scope">
					<span>{{scope.row.userId}} ~ {{scope.row.username}}</span>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="username" label="用户名称" align="center" :formatter="changeNull"></el-table-column> -->
			<el-table-column prop="" label="源用户" align="center" width="170">
				<template slot-scope="scope">
					<span v-if="scope.row.fromUserId&&scope.row.fromUsername">{{scope.row.fromUserId}} ~ {{scope.row.fromUsername}}</span>
					<span v-else>暂无</span>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="fromUsername" label="源用户名称" align="center" :formatter="changeNull"></el-table-column> -->
			<!-- <el-table-column prop="openId" label="openId" align="center" v-if="!storeFlage"> -->
				<!-- 商家不可看 -->
			<!-- </el-table-column> -->
			<el-table-column prop="storeName" label="关联商家" align="center"  v-if="!storeFlage" width="200">
				<template slot-scope="scope">
					<p v-if="scope.row.storeName">{{ scope.row.storeName }}</p>
					<p v-else>平台</p>
				</template>
				<!-- 商家不可看 -->
			</el-table-column>
			
			<!-- <el-table-column prop="phone" label="手机号" align="center"  :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="changeType" label="收支" align="center" width="80">
				<template slot-scope="scope">
					<p v-if="scope.row.changeType==0">减少</p>
					<p v-if="scope.row.changeType==1">增加</p>
				</template>
			</el-table-column>
			<el-table-column prop="sourceName" label="变动类型" align="center" width="120">
				<!-- <template slot-scope="scope">
					<p v-if="scope.row.changeType==0">减少</p>
					<p v-if="scope.row.changeType==1">增加</p>
				</template> -->
			</el-table-column>
			<el-table-column prop="isLock" label="类别" align="center" width="120">
				<template slot-scope="scope">
					<p v-if="scope.row.isLock==0">流量池</p>
					<p v-if="scope.row.isLock==1">储备积分</p>
				</template>
			</el-table-column>
			<el-table-column prop="beforeAmount" label="变动前" align="center" :formatter="changeNull" width="150">
				<template v-slot="scope">
					<span>{{scope.row.beforeAmount.toFixed(2)}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="amount" label="变动金额" align="center" :formatter="changeNull" width="150">
			</el-table-column>
			<el-table-column prop="afterAmount" label="变动后" align="center" :formatter="changeNull" width="150">
				<template v-slot="scope">
					<span>{{scope.row.afterAmount.toFixed(2)}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="remark" label="备注" align="center" :formatter="changeNull" min-width="280"></el-table-column>
			<!-- <el-table-column prop="isComplete" label="状态" align="center"  width="80" :formatter="changeNull">
				<template slot-scope="scope">
					<p v-if="scope.row.isComplete==0">未完成</p>
					<p v-if="scope.row.isComplete==1">已完成</p>
				</template>
			</el-table-column> -->
			<el-table-column prop="createTime" label="创建时间" width="200" align="center" :show-overflow-tooltip="true" >
			</el-table-column>
			<!-- <el-table-column  label="操作"  fixed="right" align="center">
                　　　　<template slot-scope="scope">
                    　　　　　　<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
                    　　　　　　<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">拨币</el-button>
                    　　　　</template>
                　　</el-table-column> -->
		</el-table>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<el-pagination style="margin: 20px;" background :current-page="userRecordList.pageNum"
				@current-change="pageChange" @size-change="handleSizeChange"
				layout="total, sizes, prev, pager, next, jumper" :total="userRecordList.total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	import moment from 'moment'; 

	export default {
		data() {
			return {
				loading: false,
				userRecordList: {}, //用户列表
				dialogVisible: false,
				typeList: [],
				integralList: [],
				integralId: "", //积分id
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {
					changeType: '',
					timer:this.timelist()
				},
				allData: {},

				storeFlage: false,

				storeList: [],
				storeLoading: false,
			};
		},
		filters: {
			intToFloatfour(val) {
				return (Math.floor(Number(val) * 10000) / 10000).toFixed(4)
			},
			cutZero(old) {
				//拷贝一份 返回去掉零的新串
				old = old + ""
				var newstr = old
				//循环变量 小数部分长度
				var i = 0
				var leng = old.length - old.indexOf(".") - 1
				//判断是否有效数
				if (old.indexOf(".") > -1) {
					//循环小数部分
					for (i = leng; i > 0; i--) {
						//如果newstr末尾有0
						if (newstr.lastIndexOf("0") > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
							var k = newstr.lastIndexOf("0")
							//如果小数点后只有一个0 去掉小数点
							if (newstr.charAt(k - 1) == ".") {
								return newstr.substring(0, k - 1)
							} else {
								//否则 去掉一个0
								newstr = newstr.substring(0, k)
							}
						} else {
							//如果末尾没有0
							return newstr
						}
					}
				}
				return old
			}

		},
		methods: {
			timelist(){
				var arr=[]
				// var date = new Date();
				// //年 getFullYear()：四位数字返回年份
				// var year = date.getFullYear();  //getFullYear()代替getYear()
				// //月 getMonth()：0 ~ 11
				// var month = date.getMonth() + 1;
				// //日 getDate()：(1 ~ 31)
				// var day = date.getDate();
				// //时 getHours()：(0 ~ 23)
				// var hour = date.getHours();
				// //分 getMinutes()： (0 ~ 59)
				// var minute = date.getMinutes();
				// //秒 getSeconds()：(0 ~ 59)
				// var second = date.getSeconds();
							
				// var time =+ year + '-' + month + '-' + day + ' ' + '00:00:00';
				// var time1 =+ year + '-' + month + '-' + day + ' ' + '23:59:59';
				let time = moment().format('YYYY-MM-DD') + ' ' + '00:00:00';
				let time1 = moment().format('YYYY-MM-DD') + ' ' + '23:59:59';
				// console.log(time1);
				arr.unshift(time1)
				arr.unshift(time)
				return arr
			},
			//导出
			downloadFile() {
				let data = {
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : time,
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : time1,
					username: this.searchInfo.username,
					userId: this.searchInfo.userId,
					fromUserId: this.searchInfo.fromUserId,
					fromUsername: this.searchInfo.fromUsername,
					changeType: this.searchInfo.changeType,
					// phone: this.searchInfo.phone,
					// intergralId: this.searchInfo.integralId,
					// source: this.searchInfo.type
				};
				//   console.log(data);				
				if (data.startTime || data.endTime) {
					this.$api.assetChangesExcel(data).then((res) => {
					console.log(res.data);
					this.showloadFile(res.data);
				});
				} else {
					this.$message.error('请选择时间')
				}
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "资产变动记录" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getUserRecordList();
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getUserRecordList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getUserRecordList()
			},
			
			getUserRecordList() {
				this.loading = true
				// let date = new Date();
				// //年 getFullYear()：四位数字返回年份
				// let year = date.getFullYear();  //getFullYear()代替getYear()
				// //月 getMonth()：0 ~ 11
				// let month = date.getMonth() + 1;
				// //日 getDate()：(1 ~ 31)
				// let day = date.getDate();
				// //时 getHours()：(0 ~ 23)
				// let hour = date.getHours();
				// //分 getMinutes()： (0 ~ 59)
				// let minute = date.getMinutes();
				// //秒 getSeconds()：(0 ~ 59)
				// let second = date.getSeconds();
			
				// let time =+ year + '-' + month + '-' + day + ' ' + '00:00:00';
				// let time1 =+ year + '-' + month + '-' + day + ' ' + '23:59:59';
					// console.log(time1);
				let time = moment().format('YYYY-MM-DD') + ' ' + '00:00:00';
				let time1 = moment().format('YYYY-MM-DD') + ' ' + '23:59:59';

				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,

					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : time,
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : time1,
					username: this.searchInfo.username,
					userId: this.searchInfo.userId,
					fromUserId: this.searchInfo.fromUserId,
					fromUsername: this.searchInfo.fromUsername,
					changeType: this.searchInfo.changeType,
					// phone: this.searchInfo.phone,
					// intergralId: this.searchInfo.integralId,
					// source: this.searchInfo.type
				}
				this.$api.getshopPoolFlowRecordList(data).then((res) => {
					// res=JSON.parse(this.$decrypt(res.data))
					console.log('六十六大神了--', res.data)
					if (res.state == 'success') {
						this.userRecordList = res.data
						this.loading = false
					} else {
						this.$message.error(res.message)
					}
				})
				// this.$api.getUserRecordListSum(this.$encrypt(data)).then((res) => {
				// 	res=JSON.parse(this.$decrypt(res.data))
				// 	if (res.state == 'success') {
				// 		this.allData = res.data
				// 	}
				// })
			},
			getRecordTypeList() {
				let data = {}
				this.$api.getRecordTypeList(this.$encrypt(data)).then((res) => {
					res=JSON.parse(this.$decrypt(res.data))
					// console.log('数据---',res )
					if (res.state == 'success') {
						this.typeList = res.data
					}
				})
			},
			useeInfo(){
				this.$api.getUserInfo(this.$encrypt({})).then((res) => {
					// console.log('登录数据1---', res.data)
					res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log('登录数据2---', res.data)
					if (res.state == 'success') {

						// storeId //不为0是店铺
						// this.storeInfo = res.data.store
						this.storeFlage = res.data.storeId==0?false:true;
					}
				})
			},
			remoteMethod(query) {
				if (query.length >= 2) {
					this.storeLoading = true;
					setTimeout(() => {
						let data = {
							storeName: query,
						}
						this.$api.getStoreNameList(data).then((res) => { //店铺管理
							if (res.state == 'success') {
								this.storeList = res.data;
							} else {
								this.$message.error(res.message);
							}
						})
						this.storeLoading = false;
					}, 200);
				} else {
					this.storeList = [];
				}
			},
		},
		created() {
			// console.log(this.timelist());
			// this.getUserRecordList();
			this.useeInfo();
			this.getRecordTypeList();
			this.$api.getIntegralListTwo().then((res) => {
				// res=JSON.parse(this.$decrypt(res.data))
				if (res.state == 'success') {
					this.integralList = res.data
				}
			})
		}
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>
